module.exports = __webpack_public_path__ + "img/htyl.7ade3912.jpg";